document.addEventListener('alpine:init', () => {
  Alpine.data('CartFooter', () => {
    return {
      footerRoot: null,
      cartAttrRoot: null,
      _morphFooter(e) {
        const newFooterSection = querySelectorInHTMLString(
          '[data-cart-footer]',
          e.detail.response.sections['cart-footer']
        );
        
        // cart footer
        Alpine.morph(
          this.footerRoot,
          newFooterSection ? newFooterSection.outerHTML : '',
          {
            updating(el, toEl, childrenOnly, skip) {
              if (
                el.classList &&
                el.classList.contains('additional-checkout-buttons')
              ) {
                skip();
              }
            },
          }
        );

        const newCartAttrSection = querySelectorInHTMLString(
          '[data-cart-attr]',
          e.detail.response.sections['cart-footer']
        );
        Alpine.morph(
          this.cartAttrRoot,
          newCartAttrSection ? newCartAttrSection.outerHTML : ''
        );

        // cart attributes
        if(this.cartAttrRoot) {
          if(e.detail.response?.item_count > 0 || e.detail.response?.quantity > 0) {
            this.cartAttrRoot.classList.remove('hidden');
          } else {
            this.cartAttrRoot.classList.add('hidden');
          }
        }
      },
      init() {
        this.footerRoot = this.$root;
        this.cartAttrRoot = this.footerRoot.parentElement.querySelector('[data-cart-attr]');

        window.addEventListener('baseline:cart:afteradditem', (e) => {
          this._morphFooter(e);
        });

        window.addEventListener('baseline:cart:cartqtychange', (e) => {
          this._morphFooter(e);
        });
      },
    };
  });
});
